import { memo, useCallback } from 'react';

import { type SearchBoardsResponse } from '@air/api/types';
import { ChevronRight } from '@air/next-icons';

import BoardThumbnail from '~/components/BoardThumbnail/BoardThumbnail';
import { BoardSuggestionBreadcrumbs } from '~/components/SearchBar/Suggestion/BoardSuggestionBreadcrumbs';
import { SearchCommandItem } from '~/components/SearchCommand/SearchCommandItem';

export type SearchCommandBoardListItemProps = {
  board: SearchBoardsResponse;
  onSelect: (board: SearchBoardsResponse) => void;
};

export const SearchCommandBoardListItem = memo(({ board, onSelect: _onSelect }: SearchCommandBoardListItemProps) => {
  const onSelect = useCallback(() => _onSelect(board), [board, _onSelect]);

  return (
    <SearchCommandItem data-type="board" onSelect={onSelect} value={board.id}>
      <div className="shrink-0 rounded-4 border border-grey-5 bg-grey-1 p-1">
        <BoardThumbnail board={board} sizes="40px" width={72} height={40} />
      </div>

      <div className="grow px-1">
        <div className="truncate font-medium text-14">{board.title}</div>
        {board.ancestors?.length ? <BoardSuggestionBreadcrumbs ancestors={board.ancestors ?? []} /> : null}
      </div>
      <div className="flex size-8 shrink-0 items-center">
        <ChevronRight className="w-4 text-grey-12" />
      </div>
    </SearchCommandItem>
  );
});

SearchCommandBoardListItem.displayName = 'SearchCommandBoardListItem';
